import { ChangeDetectorRef, Component, inject, OnInit, signal } from '@angular/core';
import { generateInventoryActionFormGroup, InventoryAction } from '../../models/inventory_action.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { InventoryActionService } from '../../services/inventory-action.service';
import moment from 'moment';
import { ConfirmDialogComponent } from '../../main/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ClientMessageComponent } from '../../client/client-message/client-message.component';
import { AdminService } from '../../admin/services/admin.service';
import { ActivatedRoute } from '@angular/router';
import { ProviderService } from '../provider.service';


interface IRequester {
  name: string;
  mail: string;
  phone: string;
}

@Component({
    selector: 'app-provider-buy-order',
    templateUrl: './provider-buy-order.component.html',
    styleUrls: ['./provider-buy-order.component.scss', '../provider-pricing/provider-pricing.component.scss'],
    standalone: false
})
export class ProviderBuyOrderComponent implements OnInit {
  public saving = signal(false);
  
  public company: any;

  public inventoryActionForBuyOrder: InventoryAction;

  public requester: IRequester;

  private readonly adminService = inject(AdminService);

  private readonly providerService = inject(ProviderService);
  
  private readonly route = inject(ActivatedRoute);
  
  private readonly dialog = inject(MatDialog);
  
  private readonly fb = inject(FormBuilder);

  private readonly inventoryActionService = inject(InventoryActionService);

  private readonly cdr = inject(ChangeDetectorRef);

  form: FormGroup = this.fb.group({
    id: this.fb.control(null),
    comment: this.fb.control(null),
    estimated_completion_date: this.fb.control(null, Validators.required),
    inventory_action_products: this.fb.array([]),
  });

  ngOnInit() {
    this.company = this.adminService.local$.getValue();
    this.route.queryParams.subscribe((value) => {
      if (value.access_token) {
        // TODO: Handle not found case
        this.providerService.getBuyOrder(value.access_token).subscribe((response: any) => {
          this.cdr.markForCheck();
          this.inventoryActionForBuyOrder = response.body.inventory_action_for_buy_order;
          this.form = generateInventoryActionFormGroup(this.inventoryActionForBuyOrder, {
            include_status: true,
            include_comments: true,
            include_expiration_date: true,
          });
          this.requester = response.body.requester;
        });
      }
    });
  }
  
  get requiredDeliveryDate() {
    return this.inventoryActionForBuyOrder?.extra_params?.required_delivery_date;
  }

  updateInventoryAction() {
    if (this.inventoryActionForBuyOrder.finish) return;

    const formGroup = this.form;
    const inventoryActionData = formGroup.getRawValue();
    if (inventoryActionData.status.locked) return;


    this.saving.set(true);
    if (inventoryActionData.id) {
      this.inventoryActionService.update(
        inventoryActionData.id,
        inventoryActionData,
      ).subscribe((inventoryAction) => {
        this.saving.set(false);
        if (!inventoryAction) return;

        this.cdr.detectChanges();
      });
    }
  }

  confirm() {
    if (!this.inventoryActionForBuyOrder || (this.inventoryActionForBuyOrder.finish && !this.inventoryActionForBuyOrder.draft)) return;

    const title = 'Confirmar Orden de Compra';
    this.dialog.open(ConfirmDialogComponent, {
        data: { title: title, body: 'Esta acción confirmará la orden de compra al cliente. ¿Desea continuar?' },
      }).afterClosed().subscribe((result) => {
        if (result) {
          this.saving.set(true);
          this.inventoryActionService.update(
            this.form.value.id,
            { 
              draft: false,
              extra_params: { 
                ...this.form.value.extra_params,
                answered_at: moment(),
                answered: true
              },
              should_send_notification: true, 
            }
          ).subscribe(() => {
            this.saving.set(false);
            
            this.dialog.open(ClientMessageComponent, {
              data: {
                message: 'Orden de compra confirmada',
              },
              width: '100%',
              height: '100%',
              disableClose: true,
              maxWidth: '100%',
              maxHeight: '100vh',
              minHeight: '100vh',
              panelClass: 'client-message-dialog',
            }).afterClosed();
      
          });

        }
      });
  }

}
